import { forwardRef, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@repo-level/core-front';

import { RealTimeServiceContext } from 'contexts/realTimeService';
import { AddonsContext } from 'contexts/addons';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { ModalTemplate } from 'components/ModalTemplate';
import { JackpotGemsWinPack } from 'components/JackpotGemsPack';
import { Logo } from 'components/Logo';
import { getAvailableJackpotModal } from 'helpers/jackpot';
import { amountWithCurrencySymbol } from 'helpers/currency';
import { useMedia } from 'modules/common/hooks/useMedia';

import { ScWinnerJackpot } from './styled';

import logo from 'assets/images/jackpot/logo.png';
import bg from 'assets/images/jackpot/winnerModalBg.jpg';

export const WinnerJackpotModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation('jackpot');

    const { user } = useContext(AuthContext);
    const { activeJackpot, jackpotWins } = useContext(RealTimeServiceContext);
    const { thirdPartySummaries } = useContext(AddonsContext);
    const { isMobileS } = useMedia();

    const modalSettings: ModalTemplateSettings = useMemo(() => {
      return isMobileS
        ? {
            type: 'mobile',
            mode: { type: 'background-custom', src: bg },
          }
        : {
            type: 'desktop',
            size: 'large',
            mode: { type: 'background-custom', src: bg },
          };
    }, [isMobileS]);

    const activeModal = useMemo(
      () =>
        getAvailableJackpotModal(user?.id, thirdPartySummaries, jackpotWins),
      [jackpotWins, thirdPartySummaries, user?.id]
    );

    const prize = useMemo(
      () =>
        amountWithCurrencySymbol(
          activeJackpot?.currency || 'USD',
          activeModal?.modalData?.amountCents! / 100
        ),
      [activeJackpot?.currency, activeModal?.modalData?.amountCents]
    );

    return (
      <ModalTemplate ref={ref} onClose={onClose} settings={modalSettings}>
        <ScWinnerJackpot>
          <div className="content">
            <Logo height={28} />
            <div className={'title'}>{t('congrats')}</div>
            <div className={'prize'}>
              {prize}
              <div className={'subtitle'}>{t('jackpotYouWon')}</div>
            </div>
          </div>
          <div className="logo_wrapper">
            <img className="logo" src={logo} alt="logo" />
            <JackpotGemsWinPack />
          </div>
        </ScWinnerJackpot>
      </ModalTemplate>
    );
  }
);
